module.exports = __webpack_public_path__ + "img/Group 28037@2x.2e9a1ae1.png";